import { useState, useEffect } from "react";

import httpclient from "../../../../../../Utils";
import { transformCalendarData } from "../utils/transformers";

export const useCalendarData = (driverId, year, month) => {
  const [monthData, setMonthData] = useState([]);
  const [summaryData, setSummaryData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchCalendarData = async () => {
      try {
        setLoading(true);
        setError(null);

        // Determine if we need current month or filtered month
        const now = new Date();
        const isCurrentMonth =
          year === now.getFullYear() && month === now.getMonth();

        let response;
        if (isCurrentMonth) {
          // Fetch current month data
          response = await httpclient.get(
            `/delivery/reports/drivers/delivery-report/${driverId}`
          );
        } else {
          // Fetch specific month data (month is 0-indexed, API expects 1-indexed)
          response = await httpclient.get(
            `/delivery/reports/drivers/delivery-report-filter/${driverId}?year=${year}&month=${
              month + 1
            }`
          );
        }

        if (response.data && response.data.status === 200) {
          const apiData = response.data.data;
          const transformedData = transformCalendarData(apiData.calendar);

          setMonthData(transformedData);
          setSummaryData({
            totalOrders: apiData.total_orders,
            deliveredOrders: apiData.delivered_orders,
            workingDays: apiData.total_working_days,
            totalHours: apiData.total_working_hours,
          });
        }
      } catch (err) {
        console.error("Error fetching calendar data:", err);
        setError("Failed to load delivery report. Please try again.");
      } finally {
        setLoading(false);
      }
    };

    if (driverId) {
      fetchCalendarData();
    }
  }, [driverId, year, month]);

  return { monthData, summaryData, loading, error };
};
